import React from 'react';
import styled from 'styled-components';

import useTranslation from 'next-translate/useTranslation';
import { Track, style } from '../../../api';
import { FEATURE_COLLABORATION_ENABLED } from '../../../constants/config';
import { FlatButton } from '../../common/Buttons';
import { TextBold14, TextNoMargin } from '../../common/Text';
import { mobile } from '../../../style/constants';
import TrackArtist from '../../Modals/TrackArtist';
import Dialog from '../../common/Dialog';

interface ModalProps {
  visible?: boolean;
  track: Track;
  onDismiss: () => void;
}

const ActivatedTrackModal = ({
  visible = false,
  onDismiss,
  track,
}: ModalProps) => {
  const { t } = useTranslation('myTracks');

  return (
    <Dialog open={visible} onClose={onDismiss}>
      <Container>
        <div className="content">
          <TextNoMargin fontSize="14px" mb="12px">
            {t('myTracks:trackActiveStatus') as string} <br />{' '}
            {t('myTracks:canListen') as string}
          </TextNoMargin>
          <div className="track_container">
            <Avatar
              url={track?.images?.['210x210'] ?? track?.track_img ?? ''}
            />
            <div className="track_title">
              <TextBold14>{track.title}</TextBold14>
              {FEATURE_COLLABORATION_ENABLED && <TrackArtist track={track} />}
            </div>
          </div>
        </div>
        <div className="actions_container">
          <FlatButton onClick={onDismiss}>
            {t('myTracks:okay') as string}
          </FlatButton>
        </div>
      </Container>
    </Dialog>
  );
};

const Avatar = styled.div<{ url: string }>`
  width: 90px;
  height: 90px;
  box-sizing: border-box;
  background-image: url(${(props) => props.url});
  background-size: cover;
  margin-right: 9.5px;
`;

Avatar.defaultProps = {
  url: 'https://dev.virpp.com/samples/covers/artwork3.png',
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 130px 40px 130px;
  @media ${mobile} {
    padding: 0px 16px 45px 16px;
  }

  .content {
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-bottom: 38px;
    align-items: center;
    @media ${mobile} {
      padding: 0px 46px 0px 46px;
    }
  }

  .track_container {
    display: flex;

    .track_title {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;

      ${TrackArtist} {
        margin-top: 4px;
        font-size: 12px;
        color: ${style.grey_dark_new};
      }
    }
  }

  .actions_container {
    display: flex;
    justify-content: center;
    @media ${mobile} {
      button {
        flex: 0 1 100%;
      }
    }
  }
`;

export default ActivatedTrackModal;
